import React, { Component, PropTypes } from 'react';
import { modalContentInfoActions as ModalContentInfoActions } from '../../../modals/ModalManageContentInfo';
import AddContentPanel from './AddContentPanel';
import TablePanelView from './TablePanelView';
import { CALCULATE_FONT_USAGE } from '../../../../constants/ActionTypes';
import TablePanelViewMulti from './TablePanelViewMulti';

class ConfigManage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            code: '',
            comments: '',
            selectedTheme: '',
            selectedConfig: ''
        };
    }
    setName(input) {
        this.setState({ name: input });
    }

    setCode(input) {
        this.setState({ code: input });
    }

    setComments(input) {
        this.setState({ comments: input });
    }

    setSelected(input, type) {
        if (type === 'theme') {
            this.setState({ selectedTheme: input });
        } else if (type === 'config') {
            this.setState({ selectedConfig: input });
        }
    }

    clearComments() {
        this.setState({ comments: '' });
    }
    clearCode() {
        this.setState({ code: '' });
    }

    render() {
        return (
            <main>
                <div>
                    {this.props.tableMultiColumns ? (
                        <TablePanelViewMulti
                            onSubmit={() => {
                                this.props.addConfigRow();
                                this.setState({ dummy: true });
                            }}
                            clearCode={this.clearCode.bind(this)}
                            clearComments={this.clearComments.bind(this)}
                            columns={this.props.columns}
                            changeConfigRow={this.props.changeConfigRow}
                            deleteConfigRow={this.props.deleteConfigRow}
                            editConfigRow={this.props.editConfigRow}
                            id="themes-panel"
                            isDisabled={this.props.isDisabled}
                            list={this.props.list}
                            moreButtons={this.props.moreButtons}
                            single={this.props.single}
                        >
                            {this.props.children}
                        </TablePanelViewMulti>
                    ) : (
                        <TablePanelView
                            id="themes-panel"
                            onSubmit={() => {
                                this.props.addConfigRow();
                                this.setState({ dummy: true });
                            }}
                            clearCode={this.clearCode.bind(this)}
                            clearComments={this.clearComments.bind(this)}
                            deleteConfigRow={this.props.deleteConfigRow}
                            editConfigRow={this.props.editConfigRow}
                            firstColumn={this.props.firstColumn}
                            isDisabled={this.props.isDisabled}
                            list={this.props.list}
                            moreButtons={this.props.moreButtons}
                            secondColumn={this.props.secondColumn}
                            single={this.props.single}
                            columns={this.props.columns}
                        >
                            <AddContentPanel
                                code={this.state.code}
                                comments={this.state.comments}
                                isDisabled={this.props.isDisabled}
                                setCode={this.setCode.bind(this)}
                                setComments={this.setComments.bind(this)}
                                setName={this.setName.bind(this)}
                                setSelected={this.setSelected.bind(this)}
                            />
                            {this.props.children}
                        </TablePanelView>
                    )}
                    <hr />
                </div>
            </main>
        );
    }
}

ConfigManage.propTypes = {
    tableMultiColumns: false
};

ConfigManage.propTypes = {
    children: PropTypes.element,
    onThemeDispatch: PropTypes.func,
    onConfigDispatch: PropTypes.func,
    tableMultiColumns: PropTypes.bool
};

export default ConfigManage;



// WEBPACK FOOTER //
// ./src/components/pages/pages/configurationListSettings/index.js